import classNames from 'classnames/bind';
import PropTypes from 'prop-types';
import React, { Component } from 'react';
import Image from 'yoda-core-components/lib/components/Image/Image';

import EnergyStar from '../EnergyStar/EnergyStar';
import * as styles from './ProductPromo.css';

const cx = classNames.bind(styles);

class ProductPromo extends Component {
    static defaultProps = {
        actions: {},
        promoContent: null,
        brandInfo: null,
        automationId: null,
        isEnergyStarAvailable: false,
    };

    static propTypes = {
        promoContent: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        brandInfo: PropTypes.oneOfType([PropTypes.object, PropTypes.array]),
        isEnergyStarAvailable: PropTypes.bool,
        automationId: PropTypes.string,
    };

    renderPromoContent = (promoContent) => {
        let promoContentDetails;
        const imageRatio = 0;
        const promoUrl = promoContent.url;
        if (promoContent && promoContent.destination) {
            promoContentDetails = (
                <a
                    href={promoContent.destination}
                    data-automation-id={`${this.props.automationId}-promoLink`}
                    aria-label="promoLink"
                >
                    <Image
                        automationId={`${this.props.automationId}-promoImage`}
                        src={promoUrl}
                        alt=""
                        imageRatio={imageRatio}
                    />
                </a>
            );
        } else {
            promoContentDetails = (
                <Image
                    automationId={`${this.props.automationId}-promoImage`}
                    src={promoUrl}
                    alt=" "
                    imageRatio={imageRatio}
                    aria-label="promoImage"
                />
            );
        }

        return promoContentDetails;
    };

    render() {
        const { brandInfo, promoContent, automationId, isEnergyStarAvailable } = this.props;
        const imageRatio = 0;
        return (
            <div className={cx('productPromoContainer')}>
                {brandInfo && brandInfo.url ? (
                    <div className={cx('brandLogoImage')}>
                        <Image
                            automationId={`${automationId}-brandLogo`}
                            src={brandInfo.url}
                            alt=""
                            imageRatio={imageRatio}
                            aria-label="brandLogo"
                        />
                    </div>
                ) : null}
                {promoContent && promoContent.url ? (
                    <div className={cx('promoImage')}>{this.renderPromoContent(promoContent)}</div>
                ) : null}
                <EnergyStar energyStar={isEnergyStarAvailable} />
            </div>
        );
    }
}

export default ProductPromo;
